export default "__VITE_ASSET__Cn4M$k$m__"